export default function () {
  const widgetName = 'cardWidgetSeven';
  const widgetOpts = cardWidgetSevenOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).find('.card-content').prepend(`<div class="seo-title"><span class="fancy-title">${data.items[x].Title}</span><span class="title">${data.items[x].DetailLinkText}</span></div>`)
        $(this).find('.card-widget-title').remove();
        $(this).find('.moreButton').addClass('button');
        $(this).find('.button').removeClass('moreButton');
        $(this).find('.button').removeAttr('target');
      })

      let totalItemEvents = data.items.length;

      if (totalItemEvents == 0) {
        $('.tier-four #cardWidgetSeven').remove();
        $('.tier-four .inner').addClass('singleElement');
      }

    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'LEARN MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}